import { useMutation } from "@tanstack/react-query";
import axios from "../helpers/axios";
import { LoginRequest } from "./dtos/auth.dto";
import { JourneyResponse } from "./dtos/journey.dto";

export const useLoginJourney = () => {
  return useMutation({
    mutationFn: async (payload: LoginRequest) => {
      const res = await axios.post<JourneyResponse>('/auth/login/journey', payload);
      return res.data;
    },
  });
};

export const useSendOtp = () => {
  return useMutation({
    mutationFn: async (msisdn: string) => {
      await axios.post(
        '/auth/otp',
        {},
        {
          params: { msisdn },
        }
      );
    },
  });
};
